export const filterPosting = ({ data = [] }) =>
  data?.filter((val) => Boolean(val.isPosting)) ?? [];
